(() => {
  if (customElements.get('adc-coffee-finder')) return;
  class CoffeeFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.products = JSON.parse(this.querySelector('[data-finder-products]').textContent);
      this.ui = JSON.parse(this.querySelector('[data-finder-ui]').textContent);
      this.step = 0;
      this.state = { method: '', productId: '', variantId: '', purchase: '', planId: '' };
      this.$ = selector => this.querySelector(selector);
      this.$$ = selector => [...this.querySelectorAll(selector)];
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        if (button.hasAttribute('data-method')) {
          if (this.state.method !== button.dataset.method) this.state = { method: button.dataset.method, productId: '', variantId: '', purchase: '', planId: '' };
        } else if (button.hasAttribute('data-coffee')) {
          if (this.state.productId !== button.dataset.coffee) Object.assign(this.state, { productId: button.dataset.coffee, variantId: '', purchase: '', planId: '' });
        } else if (button.hasAttribute('data-variant')) {
          if (this.state.variantId !== button.dataset.variant) Object.assign(this.state, { variantId: button.dataset.variant, purchase: '', planId: '' });
          this.prepareDelivery();
        } else if (button.hasAttribute('data-purchase')) {
          this.state.purchase = button.dataset.purchase;
        } else if (button.hasAttribute('data-step') || button.hasAttribute('data-edit')) {
          this.move(Number(button.dataset.step ?? button.dataset.edit)); return;
        } else if (button.hasAttribute('data-back')) { this.move(this.step - 1); return;
        } else if (button.hasAttribute('data-next')) {
          if (this.step === 3) { this.addToBag(); return; }
          this.move(this.step + 1); return;
        } else if (button.hasAttribute('data-reset')) {
          this.state = { method: '', productId: '', variantId: '', purchase: '', planId: '' }; this.move(0); return;
        } else return;
        this.$('[data-status]').textContent = '';
        this.update();
      });
      this.$('[data-plans]').addEventListener('change', event => { this.state.planId = event.target.value; this.update(); });
      this.update();
    }
    norm(value) { return String(value || '').toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    get product() { return this.products.find(product => String(product.id) === this.state.productId); }
    get variant() { return this.product?.variants.find(variant => String(variant.id) === this.state.variantId); }
    get plan() { return this.variant?.plans.find(plan => String(plan.id) === this.state.planId); }
    matches(product, variant, method = this.state.method) {
      const value = this.norm(variant.options[product.grindIndex]);
      const requested = this.norm(method);
      const hasExact = product.variants.some(item => this.norm(item.options[product.grindIndex]) === requested);
      const target = requested === 'v60' && !hasExact ? 'filter' : requested;
      const capsule = variant.options.some(option => /capsule/i.test(option));
      return value === target && (/capsule/.test(target) ? capsule : !capsule);
    }
    packName(product, variant) { return variant.options.filter((_, index) => index !== product.grindIndex).join(' · ') || variant.options[product.grindIndex]; }
    canAdvance(step = this.step) {
      return [Boolean(this.state.method), Boolean(this.product), Boolean(this.variant?.available), Boolean(this.variant?.available && (this.state.purchase === 'once' && !this.product.requiresPlan || this.state.purchase === 'subscribe' && this.plan))][step];
    }
    move(step) {
      if (step > this.step && !this.canAdvance()) return;
      this.step = Math.max(0, Math.min(3, step));
      if (this.step === 2) this.renderPacks();
      this.update();
      const heading = this.$(`[data-panel="${this.step}"] h3`);
      heading.focus({ preventScroll: true });
      const bounds = this.getBoundingClientRect();
      if (bounds.top < -120 || bounds.top > window.innerHeight * .6) this.$('.adc-finder__progress').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    }
    renderPacks() {
      const host = this.$('[data-packs]'); host.replaceChildren();
      const product = this.product; if (!product) return;
      const variants = product.variants.filter(variant => this.matches(product, variant));
      this.$('[data-no-pack]').hidden = variants.some(variant => variant.available);
      variants.forEach(variant => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.variant = String(variant.id);
        button.disabled = !variant.available; button.setAttribute('aria-pressed', String(String(variant.id) === this.state.variantId));
        const label = document.createElement('strong'); label.textContent = this.packName(product, variant);
        const price = document.createElement('span'); price.textContent = this.money(variant.price);
        button.append(label, price);
        if (!variant.available) { const note = document.createElement('small'); note.textContent = this.ui.sold_out; button.append(note); }
        host.append(button);
      });
    }
    prepareDelivery() {
      const variant = this.variant; if (!variant) return;
      const host = this.$('[data-plans]'); host.replaceChildren();
      variant.plans.forEach(plan => { const option = document.createElement('option'); option.value = String(plan.id); option.textContent = `${plan.name} — ${this.money(plan.price)}`; host.append(option); });
      if (!variant.plans.some(plan => String(plan.id) === this.state.planId)) this.state.planId = String(variant.plans[0]?.id || '');
      if (!this.state.purchase) this.state.purchase = variant.plans.length ? 'subscribe' : 'once';
      if (!variant.plans.length) this.state.purchase = 'once';
    }
    update() {
      const state = this.state, product = this.product, variant = this.variant, plan = this.plan;
      this.$$('[data-panel]').forEach(panel => panel.hidden = Number(panel.dataset.panel) !== this.step);
      this.$$('[data-step]').forEach(button => {
        const step = Number(button.dataset.step);
        button.disabled = step > 0 && !this.canAdvance(step - 1);
        if (step === this.step) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
        button.classList.toggle('is-complete', step < this.step);
      });
      this.$$('[data-method]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.method === state.method));
        const available = this.products.some(p => p.variants.some(v => v.available && this.matches(p, v, button.dataset.method)));
        button.disabled = !available;
        button.querySelector('[data-method-note]').textContent = available ? '' : this.ui.no_method;
      });
      let availableCoffees = 0;
      this.$$('[data-coffee-card]').forEach(card => {
        const p = this.products.find(p => String(p.id) === card.dataset.coffeeCard);
        const variants = p.variants.filter(v => v.available && this.matches(p, v));
        const button = card.querySelector('[data-coffee]'); button.disabled = !variants.length;
        button.setAttribute('aria-pressed', String(String(p.id) === state.productId));
        card.classList.toggle('is-unavailable', !variants.length);
        card.querySelector('[data-coffee-note]').textContent = variants.length ? '' : this.ui.unavailable;
        card.querySelector('[data-coffee-price]').textContent = variants.length ? this.money(Math.min(...variants.map(v => v.price))) : '';
        if (variants.length) availableCoffees++;
      });
      this.$('[data-no-coffee]').hidden = availableCoffees > 0;
      this.$$('[data-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variant === state.variantId)));
      this.$$('[data-purchase]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.purchase === state.purchase));
        button.disabled = button.dataset.purchase === 'subscribe' ? !variant?.plans.length : Boolean(product?.requiresPlan);
      });
      this.$('[data-once-price]').textContent = variant ? this.money(variant.price) : '';
      this.$('[data-sub-price]').textContent = plan ? this.money(plan.price) : '—';
      const saving = variant && plan ? Math.max(0, variant.price - plan.price) : 0;
      this.$('[data-saving]').textContent = saving ? `${this.ui.save} ${this.money(saving)} ${this.ui.per_order}` : '';
      this.$('[data-no-plan]').hidden = !variant || variant.plans.length > 0;
      this.$('[data-frequency-wrap]').hidden = state.purchase !== 'subscribe' || !variant?.plans.length;
      this.$('[data-plans]').value = state.planId;
      this.$('[data-back]').hidden = this.step === 0;
      const next = this.$('[data-next]'); next.disabled = !this.canAdvance() || Boolean(this.busy);
      next.textContent = this.busy ? this.ui.adding : this.step === 3 ? this.ui.add + ' →' : this.ui.continue + ' →';
      this.$('[data-summary-title]').textContent = product?.name || this.ui.ready;
      this.$('[data-summary-copy]').textContent = product ? product.title === product.name ? '' : product.title : this.ui.summary_copy;
      const imageHost = this.$('[data-summary-image]');
      if (imageHost.dataset.product !== state.productId) {
        imageHost.replaceChildren(); imageHost.dataset.product = state.productId;
        if (product?.image) { const image = document.createElement('img'); image.src = product.image; image.alt = product.title; image.width = 100; image.height = 120; imageHost.append(image); }
      }
      const values = [state.method, product?.name, variant ? this.packName(product, variant) : '', state.purchase === 'subscribe' ? plan?.name : state.purchase === 'once' ? this.ui.once : ''];
      this.$$('[data-edit]').forEach((button, index) => { button.disabled = index > 0 && !this.canAdvance(index - 1); button.textContent = values[index] || this.ui.choose; button.title = this.ui.change; });
      this.$('[data-total]').hidden = !variant;
      this.$('[data-total-price]').textContent = variant ? this.money(state.purchase === 'subscribe' && plan ? plan.price : variant.price) : '';
    }
    async addToBag() {
      if (!this.canAdvance(3) || this.busy) return;
      this.busy = true; this.update(); this.$('[data-status]').textContent = '';
      const item = { id: this.variant.id, quantity: 1 };
      if (this.state.purchase === 'subscribe') item.selling_plan = this.plan.id;
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.ui.error);
        this.$('[data-status]').textContent = this.ui.added;
        window.location.assign(this.dataset.cartUrl);
      } catch (error) { this.$('[data-status]').textContent = error.message || this.ui.error; this.busy = false; this.update(); }
    }
  }
  customElements.define('adc-coffee-finder', CoffeeFinder);
})();
